export const detailStrings = {
  pt: {
    back: "Todos os projetos",
    ficha: "Ficha Rápida",
    location: "Localização",
    year: "Ano",
    typology: "Tipologia",
    status: "Estado",
    chapters: ["Contextualização", "A estratégia", "O valor criado"],
    gallery: "Galeria",
    forSale: "Este imóvel encontra-se à venda.",
    forSaleCta: "Contactar via WhatsApp",
    waText: "Olá! Tenho interesse no projeto",
    loading: "A carregar…",
    notFound: "Projeto não encontrado.",
  },
  en: {
    back: "All projects",
    ficha: "Quick Facts",
    location: "Location",
    year: "Year",
    typology: "Typology",
    status: "Status",
    chapters: ["Context", "The strategy", "The value created"],
    gallery: "Gallery",
    forSale: "This property is for sale.",
    forSaleCta: "Contact via WhatsApp",
    waText: "Hello! I'm interested in the project",
    loading: "Loading…",
    notFound: "Project not found.",
  },
};
